import React from "react";
import { LiteracyForm } from "../../components";

const NewLiteracy = () => {
  return <LiteracyForm></LiteracyForm>;
};

export default NewLiteracy;
